import React, { Fragment, useEffect } from "react";
import Header from "../../Header/Header";
import PageTitle from "../../pagetitle/PageTitle";
import Footer from "../../footer/Footer";
import Scrollbar from "../../scrollbar/scrollbar";
import Marketing from "./Marketing";



const Marketingsinglepage: React.FC = () => {
    useEffect(() => {
        document.title = "Marketing | Brain Machine AI";
      }, []);
    return (
        <Fragment>
            <div className='about-page inner-page'>
                <div className="body_wrap o-clip">
                    <Header />
                    <main>
                    <PageTitle pageTitle="Marketing" pagesub="Marketing" />
                       <Marketing></Marketing>
                    </main>
                    <Footer />
                    <Scrollbar />
                </div>
            </div>
        </Fragment>
    );
};

export default Marketingsinglepage;
